module.exports = "<span data-ng-message=required>*Required</span> <span data-ng-message=pattern>*The email must be a properly formatted.</span> ";